import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Button } from '@zola/zola-ui';
import Media from 'react-media';
import cx from 'classnames';

import { TABLET_MAX } from '../../../../../lib/responsive';

import ChecklistDateNoteForm from '../../ChecklistDateNote';
import ChecklistDeleteButton from '../../ChecklistDeleteButton';
import ChecklistPreviousTaskButton from '../../ChecklistPreviousTaskButton';
import ChecklistCompleteTaskButton from '../../ChecklistCompleteTaskButton';
import ChecklistNextTaskButton from '../../ChecklistNextTaskButton';
import ChecklistTaskProTip from '../../ChecklistTaskProTip';
import ChecklistTaskSponsoredContent from '../../ChecklistTaskSponsoredContent';
import ChecklistAssignTaskButton from '../../ChecklistAssignTaskButton';

class ChecklistMobileTask extends Component {
  constructor() {
    super();

    this.state = {
      isEditing: false,
    };
  }

  toggleIsEditing = () => {
    this.setState(prevState => ({ isEditing: !prevState.isEditing }));
  };

  renderTitle = () => {
    let { title } = this.props;
    const { isEditing } = this.state;

    if (isEditing) title = 'Edit Task';

    return <h1 className="checklist__task-header">{title}</h1>;
  };

  renderTaskProTip = () => {
    const { sponsoredLink, description, url, urlText } = this.props;

    if (!description) return null;

    if (sponsoredLink) {
      return <ChecklistTaskProTip copy={description} url={url} urlText={urlText} />;
    }

    return <ChecklistTaskProTip copy={description} url={url} urlText={urlText} fullWidth />;
  };

  renderZolaTaskCta = () => {
    const { isSponsoredLinkFromZola, sponsoredLink, sponsoredLinkText } = this.props;

    if (sponsoredLink && isSponsoredLinkFromZola) return <Button role="link" href={sponsoredLink} className="checklist__task-mobile__zola-cta">{sponsoredLinkText}</Button>;

    return null;
  };

  renderSponsoredContent = () => {
    const { sponsoredLink, sponsoredLinkText, isSponsoredLinkFromZola } = this.props;

    if (!sponsoredLink) return null;

    return (
      <ChecklistTaskSponsoredContent
        url={sponsoredLink}
        urlText={sponsoredLinkText}
        isSponsoredLinkFromZola={isSponsoredLinkFromZola}
      />
    );
  };

  render() {
    const { closeTask, taskId, isCustomTask, invitePartnerViewActive } = this.props;

    return (
      <Media query={`(max-width: ${TABLET_MAX}px)`}>
        <div className={cx('checklist__task-mobile', { invitePartner__open: invitePartnerViewActive })}>
          <div className="checklist__task-mobile__header">
            {this.renderTitle()}
            <div className="checklist__task-mobile__header-right" onClick={closeTask}>
              <IconButton
                iconClassName="zola-ui-icon-close"
                className="checklist__task-mobile__button-close"
                btnStyle="tertiary"
              />
            </div>
          </div>
          <div id="checklistTaskMobileContent" className="checklist__task-mobile__content">
            <ChecklistDateNoteForm
              key={taskId}
              isCustomTask={isCustomTask}
              onEditClick={this.toggleIsEditing}
              submitCallback={this.toggleIsEditing}
            />
            <div className="checklist__task-mobile--buttons">
              <ChecklistAssignTaskButton className="checklist__mobile--buttonAssign" />
              <ChecklistDeleteButton className="checklist__mobile--buttonDelete" />
            </div>
            {this.renderZolaTaskCta()}
            {this.renderTaskProTip()}
            {this.renderSponsoredContent()}
          </div>
          <div className="checklist__task-mobile__footer">
            <ChecklistPreviousTaskButton />
            <ChecklistCompleteTaskButton />
            <ChecklistNextTaskButton />
          </div>
        </div>
      </Media>
    );
  }
}

ChecklistMobileTask.propTypes = {
  closeTask: PropTypes.func,
  taskId: PropTypes.string,
  isCustomTask: PropTypes.bool,
  isSponsoredLinkFromZola: PropTypes.bool,
  invitePartnerViewActive: PropTypes.bool,
};

ChecklistMobileTask.defaultProps = {
  isSponsoredLinkFromZola: false,
  isCustomTask: false,
  invitePartnerViewActive: false,
};

export default ChecklistMobileTask;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTask/ChecklistMobileTask/ChecklistMobileTask.jsx